export enum SwapSetAction {
  NONE = 'none',
  DROP_OFF_IN_POINT = 'drop-off-in-point',
  DROP_OFF_ON_SEMI_TRAILER = 'drop-off-on-semi-trailer',
  SWAP = 'swap',
  TRANSFER = 'transfer',
  UNLOAD_IN_POINT = 'unload-in-point',
  DELETE = 'delete',
}
